import { withAuthenticationRequired } from "@auth0/auth0-react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Container from "react-bootstrap/Container";
import Loading from "../components/loading";
import { useLocalStorage } from "usehooks-ts";
import { useCircleDarkMode } from "../hooks/useCircleDarkMode";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

// TODO: retrieve from elsewhere
const reports = [
  {
    title: "Pick",
    key: "pick",
    url: "https://dashboards.cluvio.com/dashboards/vrep-xmxr-061z/shared?sharingToken=53f9c27a-e14e-462f-9ea9-bccd84a1b5d7",
  },
  {
    title: "Order Activity Summary",
    key: "order-activity",
    url: "https://dashboards.cluvio.com/dashboards/o756-4edk-dyqx/shared?sharingToken=397838f6-fa3f-498d-9159-eb227f96d4ec",
  },
  {
    title: "Production Summary",
    key: "production-summary",
    url: "https://dashboards.cluvio.com/dashboards/vrep-xmvv-061z/shared?sharingToken=f39aabc6-2881-4d73-8db6-385e68240b01",
  },
  {
    title: "Per-Engineer Production",
    key: "engineer-production",
    url: "https://dashboards.cluvio.com/dashboards/vrep-xm5o-061z/shared?sharingToken=a444ced1-c3d7-4caa-991b-a79e2610b382",
  },
];

const reportHeight = 1200;

const ReportingPage = () => {
  const darkMode = useCircleDarkMode();
  const [searchParams, setSearchParams] = useSearchParams();
  const reportParam = searchParams.get("report");
  const defaultKey = reports[0].key;
  const [key, setKey] = useLocalStorage(
    "cc-circle-selectedreport",
    reportParam && reports.some((r) => r.key === reportParam)
      ? reportParam
      : defaultKey
  );

  // Keep key in sync with query string
  // When key changes, update the query string
  // When query string changes, update the key
  // (but avoid infinite loop)
  // Only update if different
  useEffect(() => {
    if (key && searchParams.get("report") !== key) {
      setSearchParams({
        ...Object.fromEntries(searchParams.entries()),
        report: key,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    if (
      reportParam &&
      reportParam !== key &&
      reports.some((r) => r.key === reportParam)
    ) {
      setKey(reportParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportParam]);

  return (
    <Container>
      <Tabs
        id="reports-page-tab-container"
        activeKey={key}
        onSelect={(k) => k && setKey(k)}
      >
        {reports.map((report, i) => (
          <Tab eventKey={report.key} key={`report${i}`} title={report.title}>
            <iframe
              title={report.title}
              allowFullScreen={true}
              height={reportHeight}
              width="100%"
              src={`${report.url}&darkMode=${darkMode ? "true" : "false"}`}
            ></iframe>
          </Tab>
        ))}
      </Tabs>
    </Container>
  );
};

export default withAuthenticationRequired(ReportingPage, {
  onRedirecting: () => <Loading />,
});
